export const MODALS = {
  saveFilterModal: "SAVE_FILTER_MODAL",
};

export const FILTER_POSITION = {
  horizontal: "0",
  vertical: "1"
}